import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import './Landing.css';
import Section from '../../components/containers/Section';
import Tutorial from '../../components/layout/Tutorial/Tutorial';
import { randomKey } from '../../static/utils';
import { Button } from 'reactstrap';
import { LogoIcon } from '../../components/elements/icons/Icons';
import IntroIllu from '../../components/elements/illustrations/introillu.svg';
import ValidateIllu from '../../components/elements/illustrations/landing-1.svg';
import ValidateIllu2 from '../../components/elements/illustrations/landing-2.svg';
import ValidateIllu3 from '../../components/elements/illustrations/landing-3.svg';
import ValidateIllu4 from '../../components/elements/illustrations/landing-4.svg';
import * as ROUTES from '../../constants/routes';
import SignUpModalForm from '../../components/elements/customModals/SignUpModalForm/SignUpModalForm';
import { getUserUid } from '../../static/localStorage';
import CookieConsent from 'react-cookie-consent';

class Landing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            signIn: false,
            signUp: false,
            inviteCode: randomKey(24),
            invitationKey: null,
        };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.escFunction, false);
        if (this.props.history.location.pathname.includes('/preview/') && !getUserUid()) {
            let previewPostUid = this.props.history.location.pathname;
            previewPostUid = previewPostUid.split('/');
            previewPostUid = previewPostUid[previewPostUid.length - 1];
            this.setState({ signIn: true, previewPostUid });
        }
        this.getInvitationKey();
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.escFunction, false);
    }

    componentDidUpdate(_, prevState) {
        if (!prevState.invitationKey && this.state.invitationKey) {
            this.setState({
                signUp: true,
            });
        }
    }

    getInvitationKey = () => {
        const urlParams = window.location.search.replace('?', '').split('&');
        urlParams.forEach(param => {
            const res = param.split('=');
            res[0] === 'invitationKey' && this.setState({ invitationKey: res[1] });
        });
    };

    signUpToggle = () => {
        this.setState(prevState => ({
            signUp: !prevState.signUp,
        }));
    };

    render() {
        const { signUp, previewPostUid, inviteCode, invitationKey } = this.state;
        return (
            <div className="landing-container">
                <CookieConsent
                    location="bottom"
                    buttonText="Accept Cookies"
                    style={{
                        background: '#6DA3FA',
                        boxShadow: '1px 0 5px #464A55',
                        padding: '5px 120px',
                    }}
                    buttonStyle={{
                        color: '#4e503b',
                        fontSize: '13px',
                        background: '#fff',
                        borderRadius: '32px',
                    }}
                    expires={150}
                >
                    This website uses cookies to enhance the user experience.
                </CookieConsent>

                <section className="intro-section">
                    <div className="intro-content intro-text">
                        <h1 className="section-title">
                            <p className="main-headline" style={{ color: '#77A9FA', margin: '0' }}>
                                Post your questions.
                            </p>
                            <p className="main-headline" style={{ color: '#2A569D', margin: '0' }}>
                                Donate to the best answers.
                            </p>
                            <p className="main-headline" style={{ color: '#EFBF51', margin: '0' }}>
                                Get paid for giving great advice.
                            </p>
                        </h1>
                        <p
                            className="intro"
                            style={{
                                color: '#6DA3FA',
                            }}
                        >
                            Invite friends, colleagues or all Validate users to solve your problems
                            and answer your questions.
                        </p>
                        <p
                            className="intro-sub"
                            style={{
                                color: '#6DA3FA',
                            }}
                        >
                            Filter the genius from the rubbish by getting your ideas in front of
                            friends and industry professionals for instant feedback. One good turn
                            deserves another, so you can donate to great responses and get paid for
                            giving your own advice.
                        </p>
                        <div className="w-100 d-flex align-items-start mt-5 cta-button">
                            <Button
                                className="try-us-button"
                                color="primary"
                                onClick={() => this.signUpToggle()}
                            >
                                Try us we’re{' '}
                                <span style={{ color: 'rgb(250, 109, 158)' }}>FREE!</span>
                            </Button>
                        </div>
                    </div>
                    <div className="intro-content">
                        <img src={IntroIllu} />
                    </div>
                </section>

                <SignUpModalForm
                    toggle={this.signUpToggle}
                    modal={signUp}
                    previewPostUid={previewPostUid}
                    inviteCode={inviteCode}
                    invitationKey={invitationKey}
                />

                <section className="landing-section section-color-blue">
                    <div className="section-content-wrapper">
                        <div className="section-text">
                            <img src={ValidateIllu} className="img-small" />
                        </div>
                        <div className="section-text">
                            <h2>
                                You might be a business, freelancer, or just a regular Joe Bloggs.{' '}
                                <span style={{ color: '#EFBF51', margin: '0' }}>
                                    We’re your second opinion.
                                </span>
                            </h2>
                            <p></p>
                            <p>
                                It can be hard to scale a business or make the right decision on
                                your own. With the scary big unknown you need good advice and often
                                at a moments notice.
                            </p>
                            <p>
                                We’re growing Validate into a community of industry professionals
                                who can offer just that at, a moments notice. Share your questions
                                and problems with our community and you’ll benefit from a range of
                                solutions and perspectives outside of your network.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="landing-section section-color-white">
                    <div className="section-content-wrapper">
                        <div className="section-text">
                            <h2 style={{ color: '#2A569D' }}>Fed up of endless email threads?</h2>
                            <h2 style={{ color: '#77A9FA' }}>
                                Consolidate all your questions here.
                            </h2>
                            <p></p>
                            <p>
                                When we want feedback we usually ping an email around the office.
                                The problem with emails and threads is that they just keep piling up
                                and you can easily lose track of comments.
                            </p>
                            <p>
                                With Validate you can create very specific questions and track the
                                responses. Choose the type of question and simply invite colleagues
                                to answer.
                            </p>
                            <p>
                                Validate will calculate the verdict as you go, to save you valuable
                                time, consolidating everything in one place.
                            </p>
                        </div>

                        <div className="section-text">
                            <img src={ValidateIllu2} className="img-right" />
                        </div>
                    </div>
                </section>

                <section className="landing-section section-color-blue">
                    <div className="section-content-wrapper">
                        <div className="section-text">
                            <img src={ValidateIllu3} className="img-head" />
                        </div>
                        <div className="section-text">
                            <h2>Decide what it’s worth.</h2>
                            <h2>
                                <span style={{ color: '#FFDF31' }}>Donate</span> to the best
                                answers.
                            </h2>
                            <p></p>
                            <p>
                                It can be hard to scale a business or make the right decision on
                                your own. With the scary big unknown you need good advice and often
                                at a moments notice.
                            </p>
                            <p>
                                We’re growing Validate into a community of industry professionals
                                who can offer just that at, a moments notice. Share your questions
                                and problems with our community and you’ll benefit from a range of
                                solutions and perspectives outside of your network.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="landing-section section-color-white">
                    <div className="section-content-wrapper">
                        <div className="section-text">
                            <h2 style={{ color: '#2A569D' }}>Get analytics on each question.</h2>
                            <h2 style={{ color: '#77A9FA' }}>See who’s onboard vs who’s not.</h2>
                            <p></p>
                            <p>
                                We automatically calculate the number of answers on posts which
                                offer a choice. This means you can see which answer stands out the
                                most and make sense of the feedback.
                            </p>
                        </div>

                        <div className="section-text">
                            <img src={ValidateIllu4} className="img-right" />
                        </div>
                    </div>
                </section>

                <section className="landing-section section-color-grey">
                    <h6
                        className="section-title title-center"
                        style={{ color: '#FA6D9E', textAlign: 'center' }}
                    >
                        Sign up now for launch.
                        <br />
                        <span style={{ color: '#77A9FA', fontWeight: '700' }}>
                            Get ahead of the game before everyone else.
                        </span>
                    </h6>
                    <Tutorial />
                    <div className="w-100 d-flex align-items-start justify-content-center mt-5">
                        <Button
                            className="try-us-button blue-button"
                            color="primary"
                            onClick={() => this.signUpToggle()}
                        >
                            Try us we’re FREE!
                        </Button>
                    </div>
                </section>

                <footer className="landing-footer">
                    <div>
                        <LogoIcon />
                    </div>
                </footer>
            </div>
        );
    }
}

export default compose(withRouter)(Landing);
